import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import DataGrid from '../../../../../data/Grid';
import FilePreview from '../../../../FilePreview';
import DataAction from '../../../../../data/actions';
import Loader from '../Loader';
import Error from '../Error';
import JobToolbar from './JobToolbar';
import Page from '../../../../../page';
import Utils from '../../../../../utils';

var getFilePath = function getFilePath(path) {
  if (!path || path.indexOf(':') === -1) return path;
  return path.substring(path.indexOf(':') + 1);
};

var useStyles = makeStyles({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  }
}, {
  name: 'ECDocumentsView'
});
/**
 * @param {import('./types').JobDetailsProps} props
 */

var DocumentsView = function DocumentsView(_ref) {
  var job = _ref.job,
      project = _ref.project,
      toolbar = _ref.toolbar,
      variant = _ref.variant;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedItem = _React$useState2[0],
      setSelectedItem = _React$useState2[1];

  var jobId = job.Id;
  var stage = job.Stage,
      documents = job.Documents;
  var gridProps = {
    id: 'communicationOutput',
    dataType: 'communicationOutput',
    mode: 'thumbnail',
    dataProps: {
      jobId: jobId,
      variant: variant,
      communication: project.Name
    }
  };
  var refreshTimer = null;
  React.useEffect(function () {
    var addTimeout = function addTimeout() {
      clearTimeout(refreshTimer);
      if (stage !== 'Processing' && stage !== 'Starting') return;
      refreshTimer = setTimeout(function () {
        DataAction.item({
          dataType: 'communicationRun',
          id: jobId,
          dataProps: {
            workspace: project.Workspace
          }
        }).fetch();
        DataAction.grid(gridProps).refresh({
          silent: true
        }).then(addTimeout);
      }, 2000);
    };

    if (stage === 'Processing' || stage === 'Starting') {
      addTimeout();
    }

    return function () {
      refreshTimer && clearTimeout(refreshTimer);
    };
  }, [stage, documents]);

  var onSelect = function onSelect(e, item) {
    if (!item || !item.length) return;
    setSelectedItem(item[0]);
  };

  var hasDocuments = job.Documents !== 0;
  var fileName = selectedItem && Utils.path.getFileName(selectedItem.Path);
  var classes = useStyles({});
  return React.createElement(React.Fragment, null, toolbar && React.createElement(JobToolbar, {
    job: job,
    center: fileName,
    title: toolbar.title,
    onClose: toolbar.onClose
  }), React.createElement(Page.Common, {
    margin: "none",
    navBarHidden: true
  }, hasDocuments && React.createElement("div", {
    className: classes.container
  }, React.createElement(Grid, {
    container: true,
    direction: "row",
    style: {
      height: '100%'
    }
  }, React.createElement(Grid, {
    item: true,
    style: {
      width: 500,
      backgroundColor: 'lightgray',
      height: '100%',
      overflow: 'auto'
    }
  }, React.createElement(DataGrid, Object.assign({
    key: gridProps.id
  }, gridProps, {
    onSelect: onSelect,
    autoSelectFirstValue: true,
    blockEmptyUnselect: true,
    selectable: true,
    viewProps: {
      hideModeSwitcher: true
    }
  }))), React.createElement(Grid, {
    item: true,
    xs: true,
    style: {
      position: 'relative',
      height: '100%',
      overflow: 'auto'
    }
  }, selectedItem && React.createElement(React.Fragment, null, React.createElement(FilePreview, {
    key: selectedItem.Path.includes('.emailbody') ? stage : undefined,
    workspace: selectedItem.Workspace,
    path: getFilePath(selectedItem.Path),
    fileName: Utils.path.getFileName(selectedItem.Path),
    accessToken: selectedItem.ResourceToken
  }))))), !hasDocuments && stage !== 'Processing' && stage !== 'Starting' && React.createElement(React.Fragment, null, stage === 'FinishedOK' && React.createElement(Error, null, "Successfully completed, but no documents generated."), stage === 'FinishedWithErrors' && React.createElement(Error, null, "Completed with errors and no generated document."), stage === 'Aborted' && React.createElement(Error, null, "Execution was stopped and no documents were generated.")), !hasDocuments && (stage === 'Processing' || stage === 'Starting') && React.createElement(Loader, null, "Generating Documents")));
};

export default DocumentsView;